module.exports = __webpack_public_path__ + "img/Weapon_276.f391ead2.png";